<template>
  <div id="entire_app__notfound">
    <h1>Page Not Found!</h1>
    <img draggable="false" src="@/assets/yoga.gif" alt="" />
    <p>The page you are looking for does not exist.</p>
    <button class="btn" @click="redirectToDashboard()">
      Return to Dashboard
    </button>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router/index";
var config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      role: "",
    };
  },
  mounted() {
    var userId = $store.state.UserDetails.user.id;
    this.returnToDashboard(
      `https://bookinga.herokuapp.com/api/v1/client/getClient/${userId}`
    );
  },
  methods: {
    redirectToDashboard() {
      if (this.role == "admin") {
        router.push("/admin");
      } else if (this.role == "shaloi") {
        router.push("/shaloi");
      } else {
        router.push("/dashboard");
      }
    },
    returnToDashboard(url) {
      axios
        .get(url, config)
        .then((response) => {
          if (response.data.success == true)
            return (this.role = response.data.data[0].role);
        })
        .catch((err) => {
          return alter("An error occured ");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#entire_app__notfound {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
}
button {
  width: 15vw;
  height: 7vh;
  background-color: #33353b;
  color: white;
  font-size: 1em;
  cursor: pointer;
}
button:hover {
  color: rgba(255, 255, 255, 0.829);
}
p {
  /* margin-top: 4%; */
  margin-bottom: 1%;
}
img {
  width: 35%;
  height: 55%;
  background-color: transparent;
}
@media only screen and (max-width: 600px) {
  button {
    width: 55vw;
    margin-top: 10%;
  }
  img {
    width: 65%;
  }
}
@media only screen and (min-width: 600px) and (max-width: 768px) {
  button {
    width: 60vw !important;
    margin-top: 10%;
  }
  img {
    width: 65%;
  }
}
</style>
